module.exports = __webpack_public_path__ + "img/ercode_fj.c51feecb.png";